
import { A2AMessage } from './types';
import { findAgentById } from './registry/agentRegistry';
import { publishMessage } from './communication/messagePublisher';

export async function sendA2AMessage(message: Omit<A2AMessage, 'id' | 'timestamp'>): Promise<A2AMessage> {
  return await publishMessage(message);
}

export * from './messaging/agentCapabilities';
export * from './messaging/taskManagement';
export * from './messaging/notifications';
export * from './messaging/peerCommunication';
export * from './messaging/subscriptionManager';
